<template>
  <div class="borderless-select">
    <HKLSelect
      class="hkl-select--borderless"
      :value="selectValue"
      :options="formattedOptions"
      :showSearch="false"
      placeholder=""
      @change="updateValue"
    />
  </div>
</template>
<script>
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import { DIR_DROPDOWN_ALL } from './consts'
export default {
  name: 'DropdownMenu',
  components: {
    HKLSelect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    format: {
      type: Function,
      required: true,
    },
    selected: {
      type: String,
    },
    afterSelect: {
      type: Function,
      default: () => {},
    },
    withAll: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectValue () {
      return this.selected || (this.withAll ? DIR_DROPDOWN_ALL : undefined)
    },
    formattedOptions () {
      const formattedOptions = this.options.map((option) => ({
        name: this.format(option, this.options.length),
        value: option,
      }))
      if (this.withAll) {
        formattedOptions.push({
          name: this.format(DIR_DROPDOWN_ALL, this.options.length),
          value: DIR_DROPDOWN_ALL,
        })
      }
      return formattedOptions
    },
  },
  methods: {
    updateValue (val) {
      this.afterSelect(val)
    },
  },
}
</script>
<style lang="scss" scoped>
.borderless-select {
  & ::v-deep .hkl-select--borderless {
    width: 170px;
    border: none;
    background-color: transparent;
    color: #0c3a58;

    .ant-select-selection {
      background: transparent;
      border: none;
      box-shadow: none;
    }

    .ant-select-selection-selected-value {
      font-weight: normal;
      color: #0c3a58;
    }

    .ant-select-selection__placeholder {
      font-weight: bold;
      color: #0c3a58;
    }

    .ant-select-arrow {
      color: #0c3a58;
    }
  }
}
</style>
